import { CalculateFieldNames } from 'utils/constants/fieldNames';

const currentArrBaseField = {
  name: CalculateFieldNames.CURRENT_ARR,
  value: '',
  onChange: () => {},
  placeholder: '0',
  character: '$',
  isPrefixCharacter: true,
  isMoney: true,
  useCommaFormat: true,
  isNumber: true
};

export const currentArrField = {
  label: 'Current ARR*',
  tooltip:
    'Please enter your current annual recurring revenue or annualized revenue',
  ...currentArrBaseField
};

export const nestedCurrentArrField = {
  label: 'Current ARR or Revenue',
  ...currentArrBaseField
};

export const avgDealSizeField = {
  label: 'Average Deal Size*',
  tooltip:
    'Please enter your average deal size, calculated as Total ARR or Annualized Revenue / Total Paying Customers',
  character: '$',
  name: CalculateFieldNames.AVG_DEAL_SIZE,
  value: '',
  onChange: () => {},
  isNumber: true,
  isNonZero: true,
  isPrefixCharacter: true,
  placeholder: '0',
  isMoney: true,
  useCommaFormat: true
};

export const yoyArrGrowthField = {
  label: 'YoY ARR Growth*',
  tooltip:
    'Please enter your latest YoY ARR growth (e.g., Year 2 ARR / Year 1 ARR – 1)',
  name: CalculateFieldNames.YOY_ARR,
  value: '',
  onChange: () => {},
  placeholder: '0',
  character: '%',
  isNumber: true,
  isNegative: true,
  minWarning: 0,
  maxWarning: 2000,
  warning: 'Are you sure your YoY ARR Revenue Growth is'
};

export const newLogoVelocityField = {
  label: 'New Logo Velocity',
  tooltip: 'Enter your new logo ARR YoY growth',
  name: CalculateFieldNames.NEW_LOGO_VELOCITY,
  value: '',
  onChange: () => {},
  character: '%',
  minWarning: 0,
  maxWarning: 2000,
  warning: 'Are you sure your New Logo Velocity is',
  placeholder: '0',
  isNumber: true
};

export const cacPaybackField = {
  label: 'CAC Payback Period (months)',
  tooltip:
    'Enter the number of months needed to pay back any customer acquisition costs',
  name: CalculateFieldNames.CAC_PAYBACK_PERIOD,
  value: '',
  onChange: () => {},
  isNumber: true,
  placeholder: 'Months',
  min: 0,
  max: 75,
  minWarning: 5,
  maxWarning: 40,
  warning: 'Are you sure your CAC Payback Period is'
};

export const grossMarginField = {
  label: 'Gross Margin*',
  tooltip:
    'Please enter your gross margin, calculated as Gross Profit as a % of Revenue',
  name: CalculateFieldNames.GROSS_MARGIN,
  value: '',
  onChange: () => {},
  character: '%',
  min: 0,
  max: 100,
  minWarning: 50,
  warning: 'Are you sure your Gross Margin is',
  isNumber: true,
  placeholder: '0'
};

export const fcfMarginField = {
  label: 'FCF Margin*',
  tooltip: 'Please enter your FCF margin, calculated as FCF as a % of Revenue',
  character: '%',
  name: CalculateFieldNames.FCF_MARGIN,
  value: '',
  onChange: () => {},
  isNumber: true,
  isNegative: true,
  minWarning: -100,
  warning: 'Are you sure your FCF Margin is',
  placeholder: '0'
};

export const annualRevenueBaseField = {
  name: CalculateFieldNames.ANNUAL_REVENUE,
  value: '',
  onChange: () => {},
  character: '$',
  isPrefixCharacter: true,
  isNumber: true,
  placeholder: '0',
  useCommaFormat: true
};

export const annualRevenueModalField = {
  label: 'Annual Revenue*',
  tooltip: 'Enter your latest <u><b>annual</b></u> revenue',
  ...annualRevenueBaseField
};

export const annualRevenueChartField = {
  label: 'Annual Revenue',
  ...annualRevenueBaseField
};

export const gaPercentOpexBaseField = {
  name: CalculateFieldNames.GA_PERCENT_OPEX,
  value: '',
  onChange: () => {},
  character: '%',
  placeholder: '0',
  min: 0,
  isNumber: true
};

export const gaPercentOpexField = {
  label: 'G&A',
  tooltip:
    'Please enter the approximate % corresponding to your G&A operating expenses as a % of total revenue',
  ...gaPercentOpexBaseField
};

export const gaAbsoluteOpexField = {
  name: CalculateFieldNames.GA_ABSOLUTE_OPEX,
  label: 'G&A OpEx $',
  value: '',
  onChange: () => {},
  isNumber: true,
  placeholder: '0',
  useCommaFormat: true
};

export const smPercentOpexBaseField = {
  name: CalculateFieldNames.SM_PERCENT_OPEX,
  value: '',
  onChange: () => {},
  character: '%',
  placeholder: '0',
  min: 0,
  isNumber: true
};

export const smPercentOpexField = {
  label: 'S&M',
  tooltip:
    'Please enter the approximate % corresponding to your S&M operating expenses as a % of total revenue',
  ...smPercentOpexBaseField
};

export const smAbsoluteOpexField = {
  name: CalculateFieldNames.SM_ABSOLUTE_OPEX,
  label: 'S&M OpEx $',
  value: '',
  onChange: () => {},
  isNumber: true,
  placeholder: '0',
  useCommaFormat: true
};

export const rdPercentOpexBaseField = {
  name: CalculateFieldNames.RD_PERCENT_OPEX,
  value: '',
  onChange: () => {},
  character: '%',
  placeholder: '0',
  min: 0,
  isNumber: true
};

export const rdPercentOpexField = {
  label: 'R&D',
  tooltip:
    'Please enter the approximate % corresponding to your R&D operating expenses as a % of total revenue',
  ...rdPercentOpexBaseField
};

export const rdAbsoluteOpexField = {
  name: CalculateFieldNames.RD_ABSOLUTE_OPEX,
  label: 'R&D OpEx $',
  value: '',
  onChange: () => {},
  isNumber: true,
  placeholder: '0',
  useCommaFormat: true
};

export const companyWebsiteField = {
  label: 'Company Website',
  name: 'company_website',
  value: '',
  onChange: () => {},
  placeholder: 'Enter company website',
  isWebsite: true,
  warning: 'Invalid website entered.'
};

export const newLogoArrOfGrossNewField = {
  label: 'New Logo ARR as a % of Gross New',
  name: CalculateFieldNames.NEW_LOGO_ARR_OF_GROSS_NEW,
  value: '',
  onChange: () => {},
  character: '%',
  min: 0,
  max: 100,
  placeholder: '0',
  isNumber: true
};

export const expansionArrOfGrossNewField = {
  label: 'Expansion ARR as a % of Gross New',
  name: CalculateFieldNames.EXPANSION_ARR_OF_GROSS_NEW,
  value: '',
  onChange: () => {},
  character: '%',
  min: 0,
  max: 100,
  placeholder: '0',
  isNumber: true
};

export const newLogoArrField = {
  label: 'New Logo ARR',
  name: CalculateFieldNames.NEW_LOGO_ARR,
  value: '',
  onChange: () => {},
  placeholder: '0',
  isNumber: true,
  character: '$',
  isPrefixCharacter: true,
  min: 0,
  useCommaFormat: true
};

export const expansionArrField = {
  label: 'Expansion ARR',
  name: CalculateFieldNames.EXPANSION_ARR,
  value: '',
  onChange: () => {},
  placeholder: '0',
  isNumber: true,
  isNegative: true,
  character: '$',
  isPrefixCharacter: true,
  min: 0,
  useCommaFormat: true
};

export const quickRatioField = {
  label: 'Quick Ratio',
  tooltip:
    'The quick ratio measures the growth of your recurring revenue in comparison to the contraction. Quick ratio can be calculated as Gross New ARR / Total Churned ARR',
  name: CalculateFieldNames.QUICK_RATIO,
  value: '',
  onChange: () => {},
  character: 'x',
  min: 0,
  max: 10,
  isNumber: true,
  isDecimal: true,
  placeholder: '0'
};

export const grossChurnArrField = {
  label: 'Gross Churn ARR',
  name: CalculateFieldNames.GROSS_CHURN_ARR,
  value: '',
  onChange: () => {},
  placeholder: '0',
  isNumber: true,
  character: '$',
  isPrefixCharacter: true,
  isNegative: true,
  forceNegativeSign: true,
  max: 0,
  useCommaFormat: true
};

export const grossDollarRetentionField = {
  label: 'Gross Dollar Retention',
  name: CalculateFieldNames.GROSS_DOLLAR_RETENTION,
  tooltip:
    'Enter your annualized gross dollar retention or use our module to calculate it',
  value: '',
  onChange: () => {},
  character: '%',
  min: 0,
  max: 100,
  minWarning: 50,
  warning: 'Are you sure your Gross Dollar Retention is',
  isNumber: true,
  placeholder: '0'
};

export const netDollarRetentionField = {
  label: 'Net Dollar Retention',
  tooltip:
    'Please enter your net dollar retention. This can be calculated by looking at your LTM customer cohort retention, or calculated using this formula: 1 + ((Expansion - Downsell - Churn) / (Average of Beginning ARR + Ending ARR))',
  name: CalculateFieldNames.NET_DOLLAR_RETENTION,
  value: '',
  onChange: () => {},
  character: '%',
  min: 0,
  max: 200,
  isNumber: true,
  minWarning: 80,
  maxWarning: 130,
  warning: 'Are you sure your Net Dollar Retention is',
  placeholder: '0'
};

export const BOPArrField = {
  label: 'Beginning of Period ARR',
  name: CalculateFieldNames.BOP_ARR,
  value: '',
  onChange: () => {},
  placeholder: '0',
  isNumber: true,
  character: '$',
  isPrefixCharacter: true,
  min: 0,
  useCommaFormat: true
};

export const netMagicNumberField = {
  label: 'Net Magic Number',
  tooltip:
    'Net magic number can be calculated as current quarter net new ARR / sales & marketing expense. Depending on the length of your sales cycle, you can use S&M expense from the current or last quarter.',
  name: CalculateFieldNames.NET_MAGIC_NUMBER,
  value: '',
  onChange: () => {},
  character: 'x',
  min: 0,
  max: 10,
  isNumber: true,
  isDecimal: true,
  maxWarning: 5,
  warning: 'Are you sure your Net Magic Number is',
  placeholder: '0'
};

export const smOpExField = {
  label: 'S&M OpEx',
  name: CalculateFieldNames.SM_OPEX,
  value: '',
  onChange: () => {},
  placeholder: '0',
  character: '$',
  isPrefixCharacter: true,
  isNumber: true,
  useCommaFormat: true
};

export const ruleOf40Field = {
  label: 'Rule of 40*',
  tooltip:
    'This is calculated based on the YoY Growth rate and FCF Margin you submitted',
  name: CalculateFieldNames.RULE_OF_40,
  value: '',
  onChange: () => {},
  character: '%',
  placeholder: '0',
  maxWarning: 200,
  isNumber: true,
  warning: 'Are you sure your Rule of 40 is'
};

export const burnMultipleField = {
  label: 'Burn Multiple',
  tooltip:
    'Burn multiple can be calculated as the absolute value of your burn (usually FCF or EBITDA) divided by net new ARR in the same period. Burn multiple is generally only calculated for companies with negative free cash flow',
  name: CalculateFieldNames.BURN_MULTIPLE,
  value: '',
  onChange: () => {},
  character: 'x',
  min: 0,
  max: 10,
  isNumber: true,
  isDecimal: true,
  maxWarning: 5,
  warning: 'Are you sure your Burn Multiple is',
  placeholder: '0'
};

export const fcfField = {
  label: 'FCF',
  name: CalculateFieldNames.FCF,
  value: '',
  onChange: () => {},
  placeholder: '0',
  character: '$',
  isPrefixCharacter: true,
  isNumber: true,
  isNegative: true,
  minWarning: -100,
  warning: 'Are you sure your FCF is',
  useCommaFormat: true
};

export const netNewArrField = {
  label: 'Net New ARR',
  name: CalculateFieldNames.NET_NEW_ARR,
  value: '',
  onChange: () => {},
  placeholder: '0',
  isNumber: true,
  character: '$',
  isPrefixCharacter: true,
  maxWarning: 100000000,
  warning: 'Are you sure your Net New Arr is',
  useCommaFormat: true
};

export const gaHeadcountPercentField = {
  label: 'G&A',
  tooltip:
    'Please enter the total number of full-time employees in your G&A organization',
  name: CalculateFieldNames.GA_HEADCOUNT_PERCENT,
  value: '',
  onChange: () => {},
  isNumber: true,
  min: 0,
  placeholder: '0',
  character: '%'
};

export const smHeadcountPercentField = {
  label: 'S&M',
  tooltip:
    'Please enter the total number of full-time employees in your S&M organization',
  name: CalculateFieldNames.SM_HEADCOUNT_PERCENT,
  value: '',
  onChange: () => {},
  isNumber: true,
  min: 0,
  placeholder: '0',
  character: '%'
};

export const rdHeadcountPercentField = {
  label: 'R&D',
  tooltip:
    'Please enter the total number of full-time employees in your R&D organization',
  name: CalculateFieldNames.RD_HEADCOUNT_PERCENT,
  value: '',
  onChange: () => {},
  isNumber: true,
  min: 0,
  placeholder: '0',
  character: '%'
};

export const totalHeadcountField = {
  label: 'Total Headcount (FTE)',
  name: CalculateFieldNames.TOTAL_HEADCOUNT,
  value: '',
  onChange: () => {},
  placeholder: 'Enter total headcount',
  isNumber: true,
  min: 0
};

export const gaFteField = {
  label: 'G&A FTE',
  name: CalculateFieldNames.GA_HEADCOUNT,
  value: '',
  onChange: () => {},
  placeholder: '0',
  isNumber: true,
  min: 0
};

export const smFteField = {
  label: 'S&M FTE',
  name: CalculateFieldNames.SM_HEADCOUNT,
  value: '',
  onChange: () => {},
  placeholder: '0',
  isNumber: true,
  min: 0
};

export const rdFteField = {
  label: 'R&D FTE',
  name: CalculateFieldNames.RD_HEADCOUNT,
  value: '',
  onChange: () => {},
  placeholder: '0',
  isNumber: true,
  min: 0
};

export const arrPerFteField = {
  label: 'ARR per FTE',
  name: CalculateFieldNames.ARR_PER_FTE,
  tooltip:
    'This is calculated based on the ARR / Revenue and Total Headcount you submitted',
  value: '',
  onChange: () => {},
  character: '$',
  isPrefixCharacter: true,
  placeholder: '0',
  minWarning: 10000,
  maxWarning: 400000,
  isNumber: true,
  warning: 'Are you sure your ARR per FTE is',
  useCommaFormat: true
};

export const opexPerFteField = {
  label: 'OpEx per FTE',
  tooltip:
    'Enter your OpEx per FTE (Total Annual OpEx divided by all full-time employees in your organization)',
  name: CalculateFieldNames.OPEX_PER_FTE,
  character: '$',
  isPrefixCharacter: true,
  value: '',
  onChange: () => {},
  placeholder: '0',
  isNumber: true,
  minWarning: 10000,
  maxWarning: 800000,
  warning: 'Are you sure your OpEx per FTE is',
  useCommaFormat: true
};

export const totalOpexField = {
  label: 'Total OpEx',
  name: CalculateFieldNames.TOTAL_OPEX,
  value: '',
  onChange: () => {},
  placeholder: '0',
  character: '$',
  isPrefixCharacter: true,
  isNumber: true,
  useCommaFormat: true
};
